import React from 'react';
import { useDispatch } from 'react-redux';

import { useUserData } from 'app/main/components';
import { showResetPasswordDialog } from './components/ResetPasswordDialog';

function LoginProvider({ children }: { children: React.ReactNode }) {
	const dispatch = useDispatch();
	const userData = useUserData();

	React.useEffect(() => {
		if (userData.user_force_reset_password) dispatch(showResetPasswordDialog());
	}, [userData.user_force_reset_password, dispatch]);

	return children;
}

export default LoginProvider;
